module.exports = "\r\n<!--<span>&copy; {{settings.getAppSetting('year')}} - {{ settings.getAppSetting('name') }}</span>-->\r\n"